null


// WEBPACK FOOTER //
// /Volumes/workplace/commands/StartTextDetectionCommand.ts